import { ADD_ERROR, ADD_WARNING, ADD_SUCCESS, ADD_INFO } from './constants'
import { SEVERITY_ERROR, SEVERITY_WARNING, SEVERITY_SUCCESS, SEVERITY_INFO } from '../constants'
import { createToast } from '../api'
import { getActiveQueueName } from '../queue/selectors'

export function addError(options = {}) {
    return (dispatch, getState) => {
        const queue = getActiveQueueName(getState())
        dispatch({
            type: ADD_ERROR,
            payload: createToast(options, SEVERITY_ERROR, queue),
        })
    }
}

export function addWarning(options = {}) {
    return (dispatch, getState) => {
        const queue = getActiveQueueName(getState())
        dispatch({
            type: ADD_WARNING,
            payload: createToast(options, SEVERITY_WARNING, queue),
        })
    }
}

export function addSuccess(options = {}) {
    return (dispatch, getState) => {
        const queue = getActiveQueueName(getState())
        dispatch({
            type: ADD_SUCCESS,
            payload: createToast(options, SEVERITY_SUCCESS, queue),
        })
    }
}

export function addInfo(options = {}) {
    return (dispatch, getState) => {
        const queue = getActiveQueueName(getState())
        dispatch({
            type: ADD_INFO,
            payload: createToast(options, SEVERITY_INFO, queue),
        })
    }
}



// WEBPACK FOOTER //
// ./src/features/Toaster/data/notifications/actions.js